import React from 'react';

export default class Loading extends React.Component {
    static defaultProps = {
        disableAll: false,
        noSpace: false,
    }
    render() {
        return (
            <div className={this.props.className + " " + (this.props.noSpace ? ('loading no-space') : ('loading'))}>
                {this.props.disableAll ? (<div className='backdrop'></div>) : (false)}
                <div className='loading-icon-container'>
                    <div className='loading-icon text-center fa-3x'>
                        <i className="fa fa-spinner  fa-spin"></i>
                    </div>
                </div>
            </div>
        );
    }
}